var focusRing = function focusRing(theme) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  var extension = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  return {
    ':focus-visible': {
      outline: 'none',
      [extension]: {
        outlineStyle: 'solid',
        outlineWidth: "".concat(size, "px"),
        outlineOffset: "".concat(offset, "px"),
        outlineColor: theme.color.focus.default
      }
    }
  };
};
export var doubleFocusRing = _ref => {
  var {
    theme,
    outlineSize = 2,
    outlineOffset = 2,
    shadowSize = 0,
    shadowInset = false,
    extension = ''
  } = _ref;
  return {
    ':focus-visible': {
      outline: 'none',
      [extension]: {
        boxShadow: "0px 0px 0px  ".concat(shadowSize, "px ").concat(theme.color.focus.inverse, " ").concat(shadowInset ? 'inset' : ''),
        outlineStyle: 'solid',
        outlineWidth: "".concat(outlineSize, "px"),
        outlineOffset: "".concat(outlineOffset, "px"),
        outlineColor: theme.color.focus.default
      }
    }
  };
};
export default focusRing;